<script lang="ts">
	export let message: string;
</script>

<p class={`${$$props.class} validation`}>{message}</p>

<style lang="scss">
	@import 'validation';
</style>